var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortugal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 28.5992 5.4275 35.9301 13.0434 38.7559L14.7826 19.9999L13.0434 1.24399C5.4275 4.06993 0 11.4007 0 20Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 20C39.9998 8.9544 31.0454 3.05176e-05 19.9998 3.05176e-05C17.5534 3.05176e-05 15.2099 0.440109 13.0432 1.24401V38.756C15.2099 39.56 17.5534 40 19.9998 40C31.0454 40 39.9998 31.0457 39.9998 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 26.9565C16.8854 26.9565 19.9999 23.8419 19.9999 20C19.9999 16.158 16.8854 13.0435 13.0435 13.0435C9.2015 13.0435 6.08698 16.158 6.08698 20C6.08698 23.8419 9.2015 26.9565 13.0435 26.9565Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13025 16.5217V20.8695C9.13025 23.0306 10.8821 24.7826 13.0433 24.7826C15.2045 24.7826 16.9563 23.0307 16.9563 20.8695V16.5217H9.13025Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 22.1739C12.3243 22.1739 11.7391 21.5888 11.7391 20.8696V19.1305H14.3478V20.8696C14.3478 21.5888 13.7627 22.1739 13.0435 22.1739Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugal);
export default __webpack_public_path__ + "static/media/portugal.f61d2a46fc2343e095cba4827da28658.svg";
export { ForwardRef as ReactComponent };